// extracted by mini-css-extract-plugin
module.exports = {"defaultImage":"E5RDS0"};